import React from "react";

// 1. Error string to user-friendly message mapping
export const PAYOUT_ERROR_MESSAGES: Record<string, string> = {
  "PayPal payout unclaimed":
    "Your payout is waiting to be claimed in your PayPal account. Please log in to PayPal and accept your payment.",

  "As the recipient's country can't receive payments, this transaction is not allowed.":
    "We couldn't send your payout because PayPal blocked this transaction due to country restrictions. We're working on new payment options. To help us pay you, please fill out this form with your country and preferred payment method. If you need help, contact us at help@perle.ai.",

  "This transaction was declined due to risk concerns.":
    "We couldn't send your payout because PayPal blocked this transaction due to risk concerns. Please check your PayPal account for details.",

  "This transaction is blocked due to regulatory compliance reasons.":
    "We couldn't send your payout because PayPal blocked this transaction due to compliance restrictions. We're working on new payment options. To help us pay you, please fill out this form with your country and preferred payment method. If you need help, contact us at help@perle.ai.",

  "The recipient has exceeded the receiving limit.":
    "We couldn't send your payout because you've reached your PayPal receiving limit. Please log in to your PayPal account and follow the instructions to verify your account or increase your receiving limit.",

  "We are holding the money temporarily because either you filed a dispute or we are reviewing the transaction. Look for an email from us with more information about this transaction.":
    "Your payout is temporarily on hold while PayPal reviews the transaction. Please check your PayPal email for more information.",

  "The receiver's account is locked or inactive. Any payment made to this account will appear as FAILED. You can contact the recipient to request them to activate their account.":
    "We couldn't send your payout because your PayPal account is locked or inactive. Please log in to your PayPal account and follow the instructions to activate or unlock your account. If you need further assistance, contact us at help@perle.ai.",
};

// 2. User-friendly error mapping logic
export function getUserFriendlyPayoutError(
  errorMessage: string | null | undefined
): string | null {
  if (!errorMessage) return null;

  // Special case: invalid contact format (phone/email)
  if (errorMessage.startsWith("Invalid payment contact format")) {
    return "Your PayPal payment contact details are invalid. Please update your payment information with a valid email address or phone number.";
  }

  // Normalize for matching: trim & lowercase
  const normalized = errorMessage.trim().toLowerCase();
  for (const key in PAYOUT_ERROR_MESSAGES) {
    if (normalized.includes(key.trim().toLowerCase())) {
      return PAYOUT_ERROR_MESSAGES[key];
    }
  }

  // Fallback message
  return "We couldn't process your payout due to a technical issue. Please contact support at help@perle.ai or try again later.";
}

// 3. Render "fill out this form" as a clickable link
const FORM_URL = "https://forms.gle/5RGC5AyB81ZjD4ME6";

export function renderErrorMessageWithLink(message: string | null) {
  if (!message) return null;
  const linkText = "fill out this form";
  const parts = message.split(linkText);

  if (parts.length === 1) return message; // No link needed

  return (
    <>
      {parts[0]}
      <a
        href={FORM_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="underline font-semibold"
      >
        {linkText}
      </a>
      {parts[1]}
    </>
  );
}
